import { RolesState } from '@core/roles/store/state/roles.state';

export const rolesState = [RolesState];
